import { HermesSvg } from "@hermes/aphrodite-svg";
import { SocialNetworkName } from "@hermes/api-model-shell";

/**
 * Allow to map API Social Icon to SVGs
 * @param socialIcon
 */
export function mapSocialIconToSVGs(socialIcon: SocialNetworkName): HermesSvg {
    if (socialIcon === "livechat") {
        return "chat-bubble";
    }

    return socialIcon;
}
